export var toNameValueObject = function(option) {
    if (typeof option === "string") {
        return {
            name: option,
            value: option
        };
    }
    if (typeof option === "number") {
        return {
            name: option.toString(),
            value: option
        };
    }
    return option;
};

//# sourceMappingURL=data-mappers.js.map